import { KampaayDataProvider } from 'services/api/dataProvider'
import { FoodUpselling } from 'services/api/entities/catalog/foodUpselling/types/internal/foodUpselling-models'
import { parseCsvFields } from 'services/utils/multilangParseWrite'
import { EntityDescriptor } from '.'
import { formatPriceRange } from './common'

export const foodsupselling: EntityDescriptor<FoodUpselling> = {
  format:
    (_dataProvider?: KampaayDataProvider) =>
    ({ name, description, minQuantity, ...record }) => ({
      id: record.id,
      ...parseCsvFields({ name, description: description ?? '' }),
      logistics: record.logistics,
      facets: record.facets,
      priceRanges: record.pricing.map(formatPriceRange),
      'Min quantity': minQuantity,
    }),
}
